// /pwa/groupby


import { API, METHODS } from '../constants';
import { fetchData } from '../utils';

export const getGroupBy = async ({ data = {} }) => {
  const url = API.GROUP_BY;
  const response = await fetchData({ body: { ...data }, method: METHODS.POST, url });
  return response;
};

export const getLastMessageId = async () => {
  const url = API.LAST_MESSAGE_ID;
  const response = await fetchData({ body: {}, method: METHODS.POST, url });
  return response;
};